import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
    {path: '', redirectTo: '/public/login', pathMatch: 'full'},
    {path: 'public', loadChildren: () => import('./public/public.module').then(m => m.PublicModule)},
    {path: 'secure', loadChildren: () => import('./secure/secure.module').then(m => m.SecureModule)},
    {path: '**', redirectTo: '/public/login'},
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
